import $ from 'cash-dom'

if (window.Pura.isInApp) {
  if (Pura.isInApp_Ios && Pura.isInApp_Ios_4_5) {
    const marginBottomSelectors = [
      '#collection-filters-mb',
      '#collection-filters-strength',
      '[data-element="bys-scroll-container"]',
    ]

    const paddingBottomSelectors = [
      '[data-element="bys-sticky"]',
      '.cart-panel',
      '#mobile-footer',
      '[data-element="modal-data"]',
    ]

    const bottomPadding = '4rem'

    marginBottomSelectors.forEach((el) => {
      const elements = $(el)
      if (elements.length) {
        elements.css('margin-bottom', bottomPadding)
      }
    })

    paddingBottomSelectors.forEach((el) => {
      const elements = $(el)
      if (elements.length) {
        elements.css('padding-bottom', bottomPadding)
      }
    })
  }

  $('#shopify-section-progress-bar-section').css('top', '68px')

  let hasHistory = false

  $(window).on('beforeunload', () => {
    hasHistory = true
  })

  $('[data-action="app-back"]').click(() => {
    window.history.back()
    setTimeout(() => {
      if (!hasHistory) {
        $('[data-action="app-back"]')
          .find('.svg-angle-left')
          .attr('stroke-opacity', 0.4)
      }
    }, 200)
    return false
  })

  $('[data-action="app-forward"]').click(() => {
    window.history.forward()
    setTimeout(() => {
      if (!hasHistory) {
        $('[data-action="app-forward"]')
          .find('.svg-angle-right')
          .attr('stroke-opacity', 0.4)
      }
    }, 200)
    return false
  })
}
